import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subscription, interval } from "rxjs";
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { SearchComponent } from '../../../shared/components/search/search.component';
import { Router } from '@angular/router';
import { BaseSearchForm } from '../../../shared/ui/base-search-form';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { FulfillmentOrder } from '../../../shared/interfaces/entities/fulfillmentOrder.interface';

@Component({
  selector: 'app-fulfillment-order',
  standalone: false,
  templateUrl: './fulfillment-order.component.html',
  styleUrl: './fulfillment-order.component.css',
  encapsulation: ViewEncapsulation.None,
})

export class FulfillmentOrderComponent extends BaseSearchForm<FulfillmentOrder> implements OnInit, OnDestroy {

  public isChecked: boolean = true; // Initial state of the switch
  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {
    super();
    this.name = "EPC Orders";
    this.formName = "FulfillmentOrder";
    this.apiController = "FulfillmentOrder";
    this.keyFieldName = "id";
    this.initializeUiControls();
    this.setGridSettings();
  }

  ngOnInit() {
   
  }

  ngOnDestroy() {

  }

  override initializeUiControls() {

    const view = new ViewControl("");

    const search = new UiGroupControl("", "Search");

    var session = this.auth.getSession();

    var row1 = new ViewRowControl();
    row1.controls.push();
    search.rows.push(row1);
    view.controls.push(search);

    this.views.push(view);
  }

  setGridSettings(): void {
    this.gridSettings = {
      gridName: "FulfillmentOrderSearch_Grid",
      showSubGrid: false,
      preloadData: true,
      columns: this.getColumns()
    };
  }

  private getColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var redeployOrderID = new UiColumn("orderNumber", "Order", 50, true, "text");
    var status = new UiColumn("status", "Status", 85, true, "text");
    var projectID = new UiColumn("projectId", "Project ID", 80, true, "text");
    var organization = new UiColumn("name", "Organization", 80, true, "text");
    var orderFulfillmentID = new UiColumn("orderFulfillmentId", "Fulfillment Order ID", 80, true, "text");
    var returnOrder = new UiColumn("returnOrder", "Return Order", 85, true, "text");
    //var dateInQueue = new UiColumn("dateInQueue", "fulfillment-order-sla.dateInQueue", 125, true, "date");
    //dateInQueue.format = "MM/dd/yyyy";

    cols.push(redeployOrderID, status, organization, projectID, orderFulfillmentID, returnOrder);

    return cols;
  }

}

